export default "__VITE_ASSET__DjTxBuMV__"